import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useMemo,
} from 'react';
import DonateModal from '../components/DonateModal/DonateModal';
import PoemModal from '../features/landing/components/PoemModal';

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [isDonateModalOpen, setIsDonateModalOpen] = useState(false);
  const [isPoemModalOpen, setIsPoemModalOpen] = useState(false);

  const openModal = useCallback(() => setIsDonateModalOpen(true), []);
  const closeModal = useCallback(() => setIsDonateModalOpen(false), []);

  const openPoemModal = useCallback(() => setIsPoemModalOpen(true), []);
  const closePoemModal = useCallback(() => setIsPoemModalOpen(false), []);

  const value = useMemo(
    () => ({
      openModal,
      openPoemModal,
    }),
    [openModal, openPoemModal]
  );

  return (
    <ModalContext.Provider value={value}>
      {children}
      <DonateModal isOpen={isDonateModalOpen} onClose={closeModal} />
      <PoemModal isOpen={isPoemModalOpen} onClose={closePoemModal} />
    </ModalContext.Provider>
  );
};

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};
